const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/amplify/login`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      register: `${ROOTS.AUTH}/amplify/register`,
      newPassword: `${ROOTS.AUTH}/amplify/new-password`,
      forgotPassword: `${ROOTS.AUTH}/amplify/forgot-password`,
      createPassword: `${ROOTS.AUTH}/amplify/create-password`,
    },
    auth0: {
      login: `${ROOTS.AUTH}/auth0/login`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    // new: `${ROOTS.DASHBOARD}/new`,
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      role: `${ROOTS.DASHBOARD}/user/role`,
      register: `${ROOTS.DASHBOARD}/user/register`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      config: `${ROOTS.DASHBOARD}/user/config`,
    },
    customer: {
      root: `${ROOTS.DASHBOARD}/customer`,
      new: `${ROOTS.DASHBOARD}/customer/new`,
      list: `${ROOTS.DASHBOARD}/customer/list`,
      details: (id: string) => `${ROOTS.DASHBOARD}/customer/${id}`,
    },
    product: {
      root: `${ROOTS.DASHBOARD}/product`,
      details: (id: string) => `${ROOTS.DASHBOARD}/product/${id}`,
      supplyList: `${ROOTS.DASHBOARD}/product/supply`,
      supply: (id: string) => `${ROOTS.DASHBOARD}/product/supply/${id}`,
      // inventory: `${ROOTS.DASHBOARD}/product/inventory`,
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      sales: `${ROOTS.DASHBOARD}/order/sales`,
      invoices: `${ROOTS.DASHBOARD}/order/invoices`,
      invoiceDetails: (id: string) => `${ROOTS.DASHBOARD}/order/invoice/${id}`,
      returnDetails: (id: string) => `${ROOTS.DASHBOARD}/order/return/${id}`,
      returnNoSale: `${ROOTS.DASHBOARD}/order/return-no-sale`,
    },
    cashRegister: {
      root: `${ROOTS.DASHBOARD}/cashRegister`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/cashRegister/${id}`,
      fund: `${ROOTS.DASHBOARD}/cashRegister/fund`,
      list: `${ROOTS.DASHBOARD}/cashRegister/list`,
    },
    reports: `${ROOTS.DASHBOARD}/reports`,
    inventory: `${ROOTS.DASHBOARD}/inventory`,
    /*
    configManagement: {
      root: `${ROOTS.DASHBOARD}/config-management`,
    }, */
  },
};
